let init = {
    gamePlayRoomList: {
        gamePlayRoomListTable: [],
        limit: 5,
        page: 0,
        totalDocs: 0,
        totalPages: 0
    },
}

const gamePlayRoomReducer = (state = init, { type, payload }) => {
    switch (type) {
        case 'GET_GAME_PLAY_ROOM_LIST': {
            return {
                ...state,
                gamePlayRoomList: {
                    gamePlayRoomListTable: payload?.docs || [],
                    totalDocs: payload?.totalDocs || 0,
                    totalPages: payload?.totalPages || 0,
                    limit: payload?.limit || 5,
                    page: (payload?.page || 1) - 1
                }
            }
        }
        case 'ADD_GAME_PLAY_ROOM_LIST': {
            return {
                ...state,
                gamePlayRoomList: {
                    ...state.gamePlayRoomList,
                    gamePlayRoomListTable: [payload, ...state.gamePlayRoomList.gamePlayRoomListTable],
                    totalDocs: Number(state.gamePlayRoomList?.totalDocs) + 1,
                }
            }
        }
        case 'UPDATE_GAME_PLAY_ROOM_LIST': {
            let temp = { ...state }
            let index = temp.gamePlayRoomList.gamePlayRoomListTable.findIndex((item) => item._id === payload._id)
            if (index > -1) {
                temp.gamePlayRoomList.gamePlayRoomListTable[index] = payload
            }
            return temp
        }
        case 'DELETE_GAME_PLAY_ROOM': {
            let filters = state.gamePlayRoomList.gamePlayRoomListTable.filter(item => item._id !== payload.gamePlayRoomPackageId)
            return {
                ...state,
                gamePlayRoomList: {
                    ...state.gamePlayRoomList,
                    gamePlayRoomListTable: filters,
                    totalDocs: Number(state.gamePlayRoomList?.totalDocs) - 1,
                }
            }
        }
        default: {
            return state
        }
    }
}

export default gamePlayRoomReducer;
